export enum ReleaseStreams {
  local = 'local',
  dev = 'dev',
  prod = 'prod',
}

export function isDebugBuild(): boolean {
  return __DEV__;
}

export function getReleaseStream(): string {
  // For web, this is passed in via a special environment variable
  if (process.env.REACT_APP_FIREBASE_EMULATOR === 'true') {
    return ReleaseStreams.local;
  }

  return process.env.REACT_APP_RELEASE_STREAM ?? ReleaseStreams.dev;
}

export function getApiUrl(): string {
  switch (getReleaseStream()) {
    // @ts-ignore - in case we have a local override
    case ReleaseStreams.prod:
      return 'https://us-central1-equity-residences.cloudfunctions.net/apiV1/api/v1/';
    // @ts-ignore - in case we have a local override
    case ReleaseStreams.dev:
      return 'https://us-central1-equity-residences-dev.cloudfunctions.net/apiV1/api/v1/';
    default:
      return 'http://localhost:5000/equity-residences/us-central1/apiV1/api/v1/';
    // return 'http://localhost:5001/equity-residences-dev/us-central1/apiV1/api/v1/';
  }
  // If you are serving functions separately (perhaps to hit prod firestore?)
  // return 'http://localhost:5001/equity-residences/us-central1/apiV1/api/v1/';
}

export function getFirebaseConfig() {
  switch (getReleaseStream()) {
    case ReleaseStreams.prod:
      return {
        apiKey: 'AIzaSyBT96SrESfdGbnjoNbLOJ0gZ8lLE7YrsH4',
        authDomain: 'equity-residences.firebaseapp.com',
        projectId: 'equity-residences',
        storageBucket: 'equity-residences.appspot.com',
        messagingSenderId: '117421145338',
        appId: '1:117421145338:web:c90dc7f700ec16e5579d43',
        measurementId: 'G-4F26BYHB1Z',
      };
    default:
      return {
        apiKey: 'AIzaSyC4QQuIeCbTnznoaO4OKdOeeXVQwWjUFrI',
        authDomain: 'equity-residences-dev.firebaseapp.com',
        projectId: 'equity-residences-dev',
        storageBucket: 'equity-residences-dev.appspot.com',
        messagingSenderId: '1078488492972',
        appId: '1:1078488492972:web:210b47a95fac80ac1fe809',
        measurementId: 'G-LCSH51ZXFX',
      };
  }
}
